import { DOCUMENT, isPlatformBrowser } from '@angular/common';
import { Component, inject, PLATFORM_ID, signal } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { Ga4AnalyticsService } from './core/analytics/ga4-analytics.service';
import { FooterComponent } from './shared/ui/footer/footer.component';
import { NavbarComponent } from './shared/ui/navbar/navbar.component';

type ThemePreference = 'light' | 'dark';

const THEME_STORAGE_KEY = 'theme-preference';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, NavbarComponent, FooterComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent {
  private readonly platformId = inject(PLATFORM_ID);
  private readonly document = inject(DOCUMENT);
  private readonly ga4AnalyticsService = inject(Ga4AnalyticsService);
  private readonly isBrowser = isPlatformBrowser(this.platformId);
  protected readonly theme = signal<ThemePreference>('light');

  public constructor() {
    this.ga4AnalyticsService.initialize();

    if (this.isBrowser && this.document.documentElement.classList.contains('dark')) {
      this.theme.set('dark');
    }
  }

  public toggleTheme(): void {
    if (!this.isBrowser) {
      return;
    }

    const nextTheme: ThemePreference = this.theme() === 'dark' ? 'light' : 'dark';

    this.document.documentElement.classList.toggle('dark', nextTheme === 'dark');
    localStorage.setItem(THEME_STORAGE_KEY, nextTheme);
    this.theme.set(nextTheme);
  }
}
